import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * Celda de la parrilla del lightbox Para Revisar.
 * Los listeners de drag van solo a la zona de imagen (no a checkbox / girar).
 */
export default function LightboxParrillaSortableCell({
  id,
  disabled,
  style: styleExtra,
  children,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    ...styleExtra,
    transform: CSS.Translate.toString(transform),
    transition: disabled ? undefined : transition,
    opacity: isDragging ? 0.55 : (styleExtra?.opacity ?? 1),
    zIndex: isDragging ? 5 : styleExtra?.zIndex,
    boxShadow: isDragging
      ? '0 8px 24px rgba(168,85,247,0.35)'
      : styleExtra?.boxShadow,
    touchAction: disabled ? undefined : 'manipulation',
  };

  return (
    <div ref={setNodeRef} style={style}>
      {typeof children === 'function'
        ? children({
          dragAttributes: attributes,
          dragListeners: disabled ? {} : listeners,
          isDragging,
        })
        : children}
    </div>
  );
}
